export const hasParent = (el: Element, predicate: (el: Element) => boolean) => {
	let parent = el.parentElement;
	while (parent != null) {
		if (predicate(parent)) return true;
		parent = parent.parentElement;
	}

	return false;
};

/** loops through the [el] and it's parents and returns the first non-undefined value of [getter] */
export const getFirstInHierarchy = <T>(el: Element, getter: (el: Element) => T | undefined) => {
	let parent: Element | null = el;
	while (parent != null) {
		const value = getter(parent);
		if (value != undefined) return value;
		parent = parent.parentElement;
	}

	return null;
};

/** loops through the [el] and it's parents and returns the first parent where [getter] is true */
export const findFirstInHierarchy = (el: Element, getter: (el: Element) => boolean) => {
	let parent: Element | null = el;
	while (parent != null) {
		if (getter(parent)) return parent;
		parent = parent.parentElement;
	}

	return null;
};

/** loops through the [el] and it's parents and returns the topmost parent where [getter] is true */
export const findEarliestInHierarchy = (
	el: Element,
	getter: (el: Element, previous: Element | undefined) => boolean,
) => {
	let parent: Element | null = el;

	let candidate: Element | undefined;
	while (parent != null) {
		if (getter(parent, candidate)) {
			candidate = parent;
		}

		parent = parent.parentElement;
	}

	return candidate;
};
